import { UserModel } from "../models/userModel";

export const userData: UserModel = {
  name: "Emre Sönmez",
  title: "Software Developer & Mechanical Engineer",
  github: "https://github.com/emresn",
  email: "contact.emresn@gmail.com",
};

export const aboutMeText: string = `


`
